<template>
  <div>

    <el-table
        class="history-table"
        v-if="loyaltyHistory"
        :data="loyaltyHistory"
        v-loading="loading"
        style="width: 100%">

      <el-table-column width="40">
        <template slot-scope="scope">
          <el-image class="history-table__icon" :src="scope.row.icon"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="Услуга">
        <template slot-scope="scope">
          <div class="procedure-title">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label=""/>

      <el-table-column label="Количество" align="right">
        <template slot-scope="scope">
          <div class="history-table__count">{{ scope.row.count }}</div>
        </template>
      </el-table-column>

      <el-table-column type="expand">
        <template slot-scope="scope">

          <el-table
              :show-header="false"
              :data="scope.row.appointments"
              style="width: 100%"
              class="expand-table"
          >
            <el-table-column>
              <template slot-scope="scope">
                <div class=" user-data">
                  <letters-avatar :name="scope.row.user.name" class="user-data__avatar" size="32" type="mini"/>
                  <div class="user-data__name">{{ scope.row.user.name }}</div>
                  <div class="user-data__phone">{{ scope.row.user.phone }}</div>
                </div>

              </template>
            </el-table-column>
            <el-table-column width="250" align="right">
              <template slot-scope="scope">

                <div class="additional-data">
                  <div class="additional-data__id">{{ scope.row.user.id }}</div>
                  <div class="additional-data__date">{{ $root.dateDefault(scope.row.start) }}</div>
                  <div class="additional-data__time"><i class="el-icon-time"></i>
                    {{ $root.timeIso(scope.row.start) }}
                  </div>
                </div>

              </template>
            </el-table-column>
            <el-table-column width="200" align="right">
              <template slot-scope="scope">
                <div class="department">
                  <i class="el-icon-location-outline"></i>
                  {{ scope.row.department.title }}
                </div>

              </template>
            </el-table-column>
          </el-table>


        </template>

      </el-table-column>

    </el-table>

    <el-pagination
        v-if="showPagination"
        class="pagination"
        background
        layout="prev, pager, next"
        :page-size="+pagination.per_page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        @current-change="loadLogic"
    />

  </div>
</template>
<script>
import LettersAvatar from "@/components/elements/LettersAvatar"

export default {
  name: "ActivityHistory",
  data() {
    return {
      pagination: {},
      loyaltyHistory: [],
      loading: false,
    }
  },
  components: {
    LettersAvatar
  },
  props: {
    user: {
      required: true
    }
  },
  watch: {
    user() {
      this.loadLogic()
    }
  },
  mounted() {
    this.loadLogic()
  },
  computed: {
    showPagination() {
      if (this.pagination) {
        return this.pagination.total >= this.pagination.per_page
      } else return false;
    },
  },
  methods: {

    loadLogic(page = 1) {

      this.loading = true

      let payLoad = {
        params: {
          page,
          limit: 4
        }
      }

      this.$api.user.getActivityHistory(this.user.id, payLoad)
          .then((response) => {
            this.loyaltyHistory = response.data.data
            if (response.data.meta)
              this.pagination = response.data.meta
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка записей 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading = false
          })
    },

  }
}
</script>
<style lang="scss" scoped>
.history-table {
  margin-top: 0;

  &__count {
    font-size: 15px;
    line-height: 16px;
    color: #111;
  }

  /deep/ tr .cell {

    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 13px;

    color: #8E8E93;
  }

  /deep/ tr:nth-child(odd) {
    background-color: #F6F8F9;
  }

  /deep/ .el-table__row {
    td {
      cursor: pointer;
      padding: 9px 0 !important;
      border-bottom: 0 !important;


    }

    td:last-child {
      border-bottom-right-radius: 4px;
      border-top-right-radius: 4px;
    }

    td:first-child {
      border-bottom-left-radius: 4px;
      border-top-left-radius: 4px;
    }
  }

  &__radio-validation {
    white-space: nowrap;
  }

  &__icon {
    width: 30px;
  }

}


.procedure-title {

  font-weight: 600;
  font-size: 15px;
  line-height: 16px;

  color: #111;

}

.date {


  &__title {
    font-size: 13px;

    color: #111111;
  }
}


.time {
  font-size: 13px;
  line-height: 1;

  display: flex;
  align-items: center;

  &__badge {
    background: #b7bac0;
    border-radius: 2px;
    padding: 2px;
    margin: 0 4px;

    color: #fff;
    font-size: 11px;
  }
}


/deep/ .el-table__expand-column {

  .el-table__expand-icon {

    .el-icon-arrow-right {
      margin-top: -16px;

      &::before {
        content: '+';

        color: #43D3B3;
        font-size: 28px;
      }
    }

  }


}


.pagination {
  padding: 0;
  margin: 10px 0 0 -5px;
}

/deep/ .el-radio {
  margin-right: 16px !important;
}

.user-data {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &__avatar {
    margin-left: 16px;
  }

  &__name {
    margin-left: 16px;


    font-weight: 600;
    font-size: 15px;
    line-height: 16px;

    color: #111;

  }

  &__phone {
    margin-left: 8px;

    color: #111;
    font-size: 15px;
    line-height: 16px;
  }
}

.department {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;

  font-size: 15px;
  line-height: 16px;

  color: #111;

  i {
    color: #43D3B3;
  }
}

.additional-data {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  font-size: 15px;
  line-height: 16px;

  &__id, &__time {
    color: #8E8E93;
  }

  &__date {
    margin: 0 12px 0 46px;
    color: #111111;

  }

}


</style>
